module.exports = __webpack_public_path__ + "media/icons/preloader-ebe58f06.svg";